import { SET_BUILDINGID, BuildingIdAction, BuildingIdState } from '../type';
const localStorageAccess = localStorage.getItem('BuildingId');

const initialState: BuildingIdState = {
    BuildingId: localStorageAccess ? localStorageAccess : '0'
};
const buildingIdReducer = (state = initialState, action: BuildingIdAction) => {
    switch (action.type) {
        case SET_BUILDINGID:
            return {
                ...state,
                BuildingId: action.payload
            };
        default:
            return state;
    }
};

export default buildingIdReducer;
